import { Pipe, PipeTransform } from '@angular/core';
import { Yii } from "libraries/interfaces/Yii";
import { LabelService } from "libraries/service/label/label.service";
import { DateMomentPipe } from "libraries/date/dateMoment.pipe";
import { HelperService } from 'libraries/hotel/services/helper.service';

@Pipe({
 name: 'generateDateWithoutPenalty'
})

export class GenerateDateWithoutPenaltyPipe implements PipeTransform {

    constructor(
        private readonly labelService: LabelService,
        private readonly dateMomentPipe: DateMomentPipe,
        private readonly helperService: HelperService
    ) {
    }

    public transform(date: string): string {
        return this.labelService.completeLabel(
            Yii.t('wui-shared-js', "Annulation gratuite jusqu'au\xa0%date%"),
            {
                date: this.dateMomentPipe.transform(date, this.getDateFormat(), true, true)
            }
        );
    }

    private getDateFormat(): string {
        return this.helperService.getDateFormat().momentShort;
    }
}